// @ts-nocheck
/* eslint-disable */
/**
 * Generated by orval v8.13.0 🍺
 * Do not edit manually.
 * SUREnet documenten-public API
 * OpenAPI spec version: 1
 */
import { useMutation, useQuery } from '@tanstack/vue-query';
import type {
  DataTag,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UseMutationOptions,
  UseMutationReturnType,
  UseQueryOptions,
  UseQueryReturnType,
} from '@tanstack/vue-query';

import { unref } from 'vue';
import type { MaybeRef } from 'vue';

import type { DocumentenSamenwerkingsovereenkomstOndertekenSamenwerkingsovereenkomstOndertekeningDto } from '../model/documentenSamenwerkingsovereenkomstOndertekenSamenwerkingsovereenkomstOndertekeningDto';

import type { DocumentenSamenwerkingsovereenkomstVerstuurSamenwerkingsovereenkomstOndertekeningsverzoekForEmailDto } from '../model/documentenSamenwerkingsovereenkomstVerstuurSamenwerkingsovereenkomstOndertekeningsverzoekForEmailDto';

import type { DocumentenSamenwerkingsovereenkomstVerstuurSamenwerkingsovereenkomstOndertekeningsverzoekForUserDto } from '../model/documentenSamenwerkingsovereenkomstVerstuurSamenwerkingsovereenkomstOndertekeningsverzoekForUserDto';

import type { Result1OfDocumentenSamenwerkingsovereenkomstGetSamenwerkingsovereenkomstDto } from '../model/result1OfDocumentenSamenwerkingsovereenkomstGetSamenwerkingsovereenkomstDto';

import type { SamenwerkingsovereenkomstBevestigOndertekeningBody } from '../model/samenwerkingsovereenkomstBevestigOndertekeningBody';

import type { SamenwerkingsovereenkomstGetParams } from '../model/samenwerkingsovereenkomstGetParams';

import { customInstance } from '../../customInstance';
import type { ErrorType } from '../../customInstance';

type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];

/**
 *  <br /> Required permissions:<br /> <ul> <li>Permission: Samenwerkingsovereenkomst.Inzien</li></ul>
 * @summary Checkt of er een samenwerkingsovereenkomst klaar staat om te ondertekenen
 */
export const samenwerkingsovereenkomstGet = (
  params?: MaybeRef<SamenwerkingsovereenkomstGetParams>,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal,
) => {
  params = unref(params);

  return customInstance<Result1OfDocumentenSamenwerkingsovereenkomstGetSamenwerkingsovereenkomstDto>(
    { url: `/api/v1/samenwerkingsovereenkomst`, method: 'GET', params: unref(params), signal },
    options,
  );
};

export const getSamenwerkingsovereenkomstGetQueryKey = (
  params?: MaybeRef<SamenwerkingsovereenkomstGetParams>,
) => {
  return ['api', 'v1', 'samenwerkingsovereenkomst', ...(params ? [params] : [])] as const;
};

export const getSamenwerkingsovereenkomstGetQueryOptions = <
  TData = Awaited<ReturnType<typeof samenwerkingsovereenkomstGet>>,
  TError = ErrorType<void>,
>(
  params?: MaybeRef<SamenwerkingsovereenkomstGetParams>,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof samenwerkingsovereenkomstGet>>, TError, TData>
    >;
    request?: SecondParameter<typeof customInstance>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = getSamenwerkingsovereenkomstGetQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof samenwerkingsovereenkomstGet>>> = ({
    signal,
  }) => samenwerkingsovereenkomstGet(params, requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof samenwerkingsovereenkomstGet>>,
    TError,
    TData
  >;
};

export type SamenwerkingsovereenkomstGetQueryResult = NonNullable<
  Awaited<ReturnType<typeof samenwerkingsovereenkomstGet>>
>;
export type SamenwerkingsovereenkomstGetQueryError = ErrorType<void>;

/**
 * @summary Checkt of er een samenwerkingsovereenkomst klaar staat om te ondertekenen
 */

export function useSamenwerkingsovereenkomstGet<
  TData = Awaited<ReturnType<typeof samenwerkingsovereenkomstGet>>,
  TError = ErrorType<void>,
>(
  params?: MaybeRef<SamenwerkingsovereenkomstGetParams>,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof samenwerkingsovereenkomstGet>>, TError, TData>
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getSamenwerkingsovereenkomstGetQueryOptions(params, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}

/**
 *  <br /> Required permissions:<br /> <ul> <li>Permission: Samenwerkingsovereenkomst.Ondertekenen</li></ul>
 * @summary Ondertekent de samenwerkingsovereenkomst
 */
export const samenwerkingsovereenkomstOnderteken = (
  documentenSamenwerkingsovereenkomstOndertekenSamenwerkingsovereenkomstOndertekeningDto?: MaybeRef<DocumentenSamenwerkingsovereenkomstOndertekenSamenwerkingsovereenkomstOndertekeningDto>,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal,
) => {
  documentenSamenwerkingsovereenkomstOndertekenSamenwerkingsovereenkomstOndertekeningDto = unref(
    documentenSamenwerkingsovereenkomstOndertekenSamenwerkingsovereenkomstOndertekeningDto,
  );

  return customInstance<void>(
    {
      url: `/api/v1/samenwerkingsovereenkomst/onderteken`,
      method: 'POST',
      headers: { 'Content-Type': 'application/json-patch+json' },
      data: documentenSamenwerkingsovereenkomstOndertekenSamenwerkingsovereenkomstOndertekeningDto,
      signal,
    },
    options,
  );
};

export const getSamenwerkingsovereenkomstOndertekenMutationOptions = <
  TError = ErrorType<void>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof samenwerkingsovereenkomstOnderteken>>,
    TError,
    {
      data?: DocumentenSamenwerkingsovereenkomstOndertekenSamenwerkingsovereenkomstOndertekeningDto;
    },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof samenwerkingsovereenkomstOnderteken>>,
  TError,
  { data?: DocumentenSamenwerkingsovereenkomstOndertekenSamenwerkingsovereenkomstOndertekeningDto },
  TContext
> => {
  const mutationKey = ['samenwerkingsovereenkomstOnderteken'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof samenwerkingsovereenkomstOnderteken>>,
    {
      data?: DocumentenSamenwerkingsovereenkomstOndertekenSamenwerkingsovereenkomstOndertekeningDto;
    }
  > = (props) => {
    const { data } = props ?? {};

    return samenwerkingsovereenkomstOnderteken(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type SamenwerkingsovereenkomstOndertekenMutationResult = NonNullable<
  Awaited<ReturnType<typeof samenwerkingsovereenkomstOnderteken>>
>;
export type SamenwerkingsovereenkomstOndertekenMutationBody =
  | DocumentenSamenwerkingsovereenkomstOndertekenSamenwerkingsovereenkomstOndertekeningDto
  | undefined;
export type SamenwerkingsovereenkomstOndertekenMutationError = ErrorType<void>;

/**
 * @summary Ondertekent de samenwerkingsovereenkomst
 */
export const useSamenwerkingsovereenkomstOnderteken = <
  TError = ErrorType<void>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof samenwerkingsovereenkomstOnderteken>>,
      TError,
      {
        data?: DocumentenSamenwerkingsovereenkomstOndertekenSamenwerkingsovereenkomstOndertekeningDto;
      },
      TContext
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseMutationReturnType<
  Awaited<ReturnType<typeof samenwerkingsovereenkomstOnderteken>>,
  TError,
  { data?: DocumentenSamenwerkingsovereenkomstOndertekenSamenwerkingsovereenkomstOndertekeningDto },
  TContext
> => {
  return useMutation(getSamenwerkingsovereenkomstOndertekenMutationOptions(options), queryClient);
};
/**
 *  <br /> Required permissions:<br /> <ul> <li>Permission: Crm.Adviseurbeheer</li></ul>
 * @summary Bevestigt dat de samenwerkingsovereenkomst fysiek is ondertekend en als apart document is geüpload om verdere herinneringen te voorkomen
 */
export const samenwerkingsovereenkomstBevestigOndertekening = (
  samenwerkingsovereenkomstBevestigOndertekeningBody?: MaybeRef<SamenwerkingsovereenkomstBevestigOndertekeningBody>,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal,
) => {
  samenwerkingsovereenkomstBevestigOndertekeningBody = unref(
    samenwerkingsovereenkomstBevestigOndertekeningBody,
  );
  const formData = new FormData();
  if (samenwerkingsovereenkomstBevestigOndertekeningBody?.['Dto.Adviseurnummer'] !== undefined) {
    formData.append(
      `Dto.Adviseurnummer`,
      samenwerkingsovereenkomstBevestigOndertekeningBody['Dto.Adviseurnummer'].toString(),
    );
  }
  if (samenwerkingsovereenkomstBevestigOndertekeningBody?.['Dto.SwoSoort'] !== undefined) {
    formData.append(
      `Dto.SwoSoort`,
      samenwerkingsovereenkomstBevestigOndertekeningBody['Dto.SwoSoort'],
    );
  }
  if (samenwerkingsovereenkomstBevestigOndertekeningBody?.['Dto.Datum'] !== undefined) {
    formData.append(`Dto.Datum`, samenwerkingsovereenkomstBevestigOndertekeningBody['Dto.Datum']);
  }
  if (samenwerkingsovereenkomstBevestigOndertekeningBody?.['Dto.OndertekendDoor'] !== undefined) {
    formData.append(
      `Dto.OndertekendDoor`,
      samenwerkingsovereenkomstBevestigOndertekeningBody['Dto.OndertekendDoor'],
    );
  }
  if (samenwerkingsovereenkomstBevestigOndertekeningBody?.File !== undefined) {
    formData.append(`File`, samenwerkingsovereenkomstBevestigOndertekeningBody.File);
  }

  return customInstance<void>(
    {
      url: `/api/v1/samenwerkingsovereenkomst/bevestig-ondertekening`,
      method: 'POST',
      headers: { 'Content-Type': 'multipart/form-data' },
      data: formData,
      signal,
    },
    options,
  );
};

export const getSamenwerkingsovereenkomstBevestigOndertekeningMutationOptions = <
  TError = ErrorType<void>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof samenwerkingsovereenkomstBevestigOndertekening>>,
    TError,
    { data?: SamenwerkingsovereenkomstBevestigOndertekeningBody },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof samenwerkingsovereenkomstBevestigOndertekening>>,
  TError,
  { data?: SamenwerkingsovereenkomstBevestigOndertekeningBody },
  TContext
> => {
  const mutationKey = ['samenwerkingsovereenkomstBevestigOndertekening'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof samenwerkingsovereenkomstBevestigOndertekening>>,
    { data?: SamenwerkingsovereenkomstBevestigOndertekeningBody }
  > = (props) => {
    const { data } = props ?? {};

    return samenwerkingsovereenkomstBevestigOndertekening(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type SamenwerkingsovereenkomstBevestigOndertekeningMutationResult = NonNullable<
  Awaited<ReturnType<typeof samenwerkingsovereenkomstBevestigOndertekening>>
>;
export type SamenwerkingsovereenkomstBevestigOndertekeningMutationBody =
  | SamenwerkingsovereenkomstBevestigOndertekeningBody
  | undefined;
export type SamenwerkingsovereenkomstBevestigOndertekeningMutationError = ErrorType<void>;

/**
 * @summary Bevestigt dat de samenwerkingsovereenkomst fysiek is ondertekend en als apart document is geüpload om verdere herinneringen te voorkomen
 */
export const useSamenwerkingsovereenkomstBevestigOndertekening = <
  TError = ErrorType<void>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof samenwerkingsovereenkomstBevestigOndertekening>>,
      TError,
      { data?: SamenwerkingsovereenkomstBevestigOndertekeningBody },
      TContext
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseMutationReturnType<
  Awaited<ReturnType<typeof samenwerkingsovereenkomstBevestigOndertekening>>,
  TError,
  { data?: SamenwerkingsovereenkomstBevestigOndertekeningBody },
  TContext
> => {
  return useMutation(
    getSamenwerkingsovereenkomstBevestigOndertekeningMutationOptions(options),
    queryClient,
  );
};
/**
 *  <br /> Required permissions:<br /> <ul> <li>Permission: Crm.Adviseurbeheer</li></ul>
 * @summary Verstuurt de uitnodiging om te ondertekenen
 */
export const samenwerkingsovereenkomstVerstuur = (
  documentenSamenwerkingsovereenkomstVerstuurSamenwerkingsovereenkomstOndertekeningsverzoekForUserDto?: MaybeRef<DocumentenSamenwerkingsovereenkomstVerstuurSamenwerkingsovereenkomstOndertekeningsverzoekForUserDto>,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal,
) => {
  documentenSamenwerkingsovereenkomstVerstuurSamenwerkingsovereenkomstOndertekeningsverzoekForUserDto =
    unref(
      documentenSamenwerkingsovereenkomstVerstuurSamenwerkingsovereenkomstOndertekeningsverzoekForUserDto,
    );

  return customInstance<void>(
    {
      url: `/api/v1/samenwerkingsovereenkomst/verstuur`,
      method: 'POST',
      headers: { 'Content-Type': 'application/json-patch+json' },
      data: documentenSamenwerkingsovereenkomstVerstuurSamenwerkingsovereenkomstOndertekeningsverzoekForUserDto,
      signal,
    },
    options,
  );
};

export const getSamenwerkingsovereenkomstVerstuurMutationOptions = <
  TError = ErrorType<void>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof samenwerkingsovereenkomstVerstuur>>,
    TError,
    {
      data?: DocumentenSamenwerkingsovereenkomstVerstuurSamenwerkingsovereenkomstOndertekeningsverzoekForUserDto;
    },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof samenwerkingsovereenkomstVerstuur>>,
  TError,
  {
    data?: DocumentenSamenwerkingsovereenkomstVerstuurSamenwerkingsovereenkomstOndertekeningsverzoekForUserDto;
  },
  TContext
> => {
  const mutationKey = ['samenwerkingsovereenkomstVerstuur'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof samenwerkingsovereenkomstVerstuur>>,
    {
      data?: DocumentenSamenwerkingsovereenkomstVerstuurSamenwerkingsovereenkomstOndertekeningsverzoekForUserDto;
    }
  > = (props) => {
    const { data } = props ?? {};

    return samenwerkingsovereenkomstVerstuur(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type SamenwerkingsovereenkomstVerstuurMutationResult = NonNullable<
  Awaited<ReturnType<typeof samenwerkingsovereenkomstVerstuur>>
>;
export type SamenwerkingsovereenkomstVerstuurMutationBody =
  | DocumentenSamenwerkingsovereenkomstVerstuurSamenwerkingsovereenkomstOndertekeningsverzoekForUserDto
  | undefined;
export type SamenwerkingsovereenkomstVerstuurMutationError = ErrorType<void>;

/**
 * @summary Verstuurt de uitnodiging om te ondertekenen
 */
export const useSamenwerkingsovereenkomstVerstuur = <TError = ErrorType<void>, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof samenwerkingsovereenkomstVerstuur>>,
      TError,
      {
        data?: DocumentenSamenwerkingsovereenkomstVerstuurSamenwerkingsovereenkomstOndertekeningsverzoekForUserDto;
      },
      TContext
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseMutationReturnType<
  Awaited<ReturnType<typeof samenwerkingsovereenkomstVerstuur>>,
  TError,
  {
    data?: DocumentenSamenwerkingsovereenkomstVerstuurSamenwerkingsovereenkomstOndertekeningsverzoekForUserDto;
  },
  TContext
> => {
  return useMutation(getSamenwerkingsovereenkomstVerstuurMutationOptions(options), queryClient);
};
/**
 *  <br /> Required permissions:<br /> <ul> <li>Permission: Crm.Adviseurbeheer</li></ul>
 * @summary Verstuurt de uitnodiging om te ondertekenen d.m.v. tijdelijke link
 */
export const samenwerkingsovereenkomstVerstuurTijdelijk = (
  documentenSamenwerkingsovereenkomstVerstuurSamenwerkingsovereenkomstOndertekeningsverzoekForEmailDto?: MaybeRef<DocumentenSamenwerkingsovereenkomstVerstuurSamenwerkingsovereenkomstOndertekeningsverzoekForEmailDto>,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal,
) => {
  documentenSamenwerkingsovereenkomstVerstuurSamenwerkingsovereenkomstOndertekeningsverzoekForEmailDto =
    unref(
      documentenSamenwerkingsovereenkomstVerstuurSamenwerkingsovereenkomstOndertekeningsverzoekForEmailDto,
    );

  return customInstance<void>(
    {
      url: `/api/v1/samenwerkingsovereenkomst/verstuur/tijdelijk`,
      method: 'POST',
      headers: { 'Content-Type': 'application/json-patch+json' },
      data: documentenSamenwerkingsovereenkomstVerstuurSamenwerkingsovereenkomstOndertekeningsverzoekForEmailDto,
      signal,
    },
    options,
  );
};

export const getSamenwerkingsovereenkomstVerstuurTijdelijkMutationOptions = <
  TError = ErrorType<void>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof samenwerkingsovereenkomstVerstuurTijdelijk>>,
    TError,
    {
      data?: DocumentenSamenwerkingsovereenkomstVerstuurSamenwerkingsovereenkomstOndertekeningsverzoekForEmailDto;
    },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof samenwerkingsovereenkomstVerstuurTijdelijk>>,
  TError,
  {
    data?: DocumentenSamenwerkingsovereenkomstVerstuurSamenwerkingsovereenkomstOndertekeningsverzoekForEmailDto;
  },
  TContext
> => {
  const mutationKey = ['samenwerkingsovereenkomstVerstuurTijdelijk'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof samenwerkingsovereenkomstVerstuurTijdelijk>>,
    {
      data?: DocumentenSamenwerkingsovereenkomstVerstuurSamenwerkingsovereenkomstOndertekeningsverzoekForEmailDto;
    }
  > = (props) => {
    const { data } = props ?? {};

    return samenwerkingsovereenkomstVerstuurTijdelijk(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type SamenwerkingsovereenkomstVerstuurTijdelijkMutationResult = NonNullable<
  Awaited<ReturnType<typeof samenwerkingsovereenkomstVerstuurTijdelijk>>
>;
export type SamenwerkingsovereenkomstVerstuurTijdelijkMutationBody =
  | DocumentenSamenwerkingsovereenkomstVerstuurSamenwerkingsovereenkomstOndertekeningsverzoekForEmailDto
  | undefined;
export type SamenwerkingsovereenkomstVerstuurTijdelijkMutationError = ErrorType<void>;

/**
 * @summary Verstuurt de uitnodiging om te ondertekenen d.m.v. tijdelijke link
 */
export const useSamenwerkingsovereenkomstVerstuurTijdelijk = <
  TError = ErrorType<void>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof samenwerkingsovereenkomstVerstuurTijdelijk>>,
      TError,
      {
        data?: DocumentenSamenwerkingsovereenkomstVerstuurSamenwerkingsovereenkomstOndertekeningsverzoekForEmailDto;
      },
      TContext
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseMutationReturnType<
  Awaited<ReturnType<typeof samenwerkingsovereenkomstVerstuurTijdelijk>>,
  TError,
  {
    data?: DocumentenSamenwerkingsovereenkomstVerstuurSamenwerkingsovereenkomstOndertekeningsverzoekForEmailDto;
  },
  TContext
> => {
  return useMutation(
    getSamenwerkingsovereenkomstVerstuurTijdelijkMutationOptions(options),
    queryClient,
  );
};
